  $('.product-block--sales-point').wrapAll('<div class="product-block--sales-point-wrapper skio-data-container"></div>');
  $('.skio-data-container,.product-subscription__option-row').wrapAll('<div class="product--block_main--container"></div>');
  $('.skio-data-container,.product-subscription__option-row').slice(1).wrapAll('<div class="product--block_secondary--container"></div>');

  const $percentageOff = $('.cstmpercentage-off');
  const $priceOff = $('.cstmprice-off');
  function toggleDiscounts() {
    const isVisible = $('.freq-button:visible').length > 0;
    $percentageOff.toggle(isVisible);
    // $priceOff.toggle(isVisible);
  }
  toggleDiscounts();
  setInterval(toggleDiscounts, 100);

  let selectedSellingPlan = null;


function setOrUpdatePrice(priceText) {
  const priceEl = $('.get_product_price');
  const priceE2 = $('.get_product_price-mb span');

  const cleanPrice = parseFloat(String(priceText).replace(/[^0-9.]/g, '')) || 0;
  const quantity = parseInt($('.js-qty__num').val(), 10) || 1;
  const totalPrice = (cleanPrice * quantity).toFixed(2);

  if (priceEl.length > 0) {
    priceEl.text(`$${totalPrice}`);
    priceE2.text(`$${cleanPrice.toFixed(2)} / each`);
  } else {
    $('.qmr_button button.add-to-cart span[data-add-to-cart-text]')
  //    .append(`<span class="get_product_price">$${totalPrice}</span>`);
  }
}

  function updatePriceDisplay() {
    const nindex = $('.quantity-button--active').attr('data-quantity') || '1';
    if (selectedSellingPlan) {
      $('.subscription-only').show();
      const priceElement = $(`.price-off-${nindex}`);
      if (priceElement.length > 0) {
       const priceText = priceElement.text().replace(/[^0-9.]/g, ''); 
        if (!isNaN(priceText)) setOrUpdatePrice(priceText);
      }
    } else {
      const defaultPrice = $('.product-single__title').attr('add_cart_price').replace('$', '');
      if (!isNaN(defaultPrice)) setOrUpdatePrice(defaultPrice);
      $('.subscription-only').hide();
    }
  }

  function updateProductData() {
    updatePriceDisplay();
  }

  setTimeout(updateProductData, 2000);
 
 

  document.addEventListener('skio::update-selling-plan', (event) => {
    selectedSellingPlan = event.detail.sellingPlan;
    const $mainContainer = $('.product--block_main--container');
    const $priceBlock = $('.product-block--price');
    const $priceMbS = $('.get_product_price-mb s');
    const $badge = $('.cstm-pdp-badge');
    
    if (selectedSellingPlan) {
      $mainContainer.addClass('main-border-btn-1').removeClass('main-border-btn-2');
      $priceBlock.hide();
      $priceMbS.show();
      $badge.show();
    } else {
      $mainContainer.addClass('main-border-btn-2').removeClass('main-border-btn-1');
      $priceBlock.show();
      $priceMbS.hide();
      $badge.hide();
    }
    updatePriceDisplay();
  });

  $('.quantity-buttons .quantity-button').click(function() {
    $('.quantity-button').removeClass('quantity-button--active');
    $(this).addClass('quantity-button--active');
    updatePriceDisplay();
  });

      const urlData = window.location.href;
      const $mainContainer = $('.product--block_main--container');
      const $priceBlock = $('.product-block--price');
      const $badge = $('.cstm-pdp-badge');
      const $priceMbS = $('.get_product_price-mb s');
      
      if (urlData.includes('selling_plan')) {
        selectedSellingPlan = true;
        $('.subscription-only').show();
        $priceBlock.hide();
        $badge.show();
        const nindexx = $('.quantity-button--active').attr('data-quantity') || '1';
        const priceElementt = $(`.price-off-${nindexx}`);
        if (priceElementt.length > 0) {
          const priceTextt = priceElementt.text().split('/')[0].replace('$', '');
         // alert('truePrice',priceTextt)
          setOrUpdatePrice(priceTextt);
        }
        $mainContainer.addClass('main-border-btn-1').removeClass('main-border-btn-2');
        $priceMbS.show();
        //alert('true')
      } else {
        $('.subscription-only').hide();
        $priceBlock.show();
        $badge.hide();
        const defaultPricee = $('.product-single__title').attr('add_cart_price').replace('$', '');
        setOrUpdatePrice(defaultPricee);
        $mainContainer.addClass('main-border-btn-2').removeClass('main-border-btn-1');
        // alert('else')
            // alert('defaultPricee',defaultPricee)
      }

 

  $(document).on('click', '.variant-input', function() {
    updateProductData();
    setTimeout(updateProductData, 1000);
  });

  $('.product__quantity').click(function() {
    const getIncreaseqty = parseInt($('.js-qty__num').val(), 10) || 1;
    const isPriceOff4Visible = $('.price-off-4:visible').length > 0;
    let onClickPrice;

    if (getIncreaseqty < 5) {
      onClickPrice = isPriceOff4Visible
        ? $(`.price-off-${getIncreaseqty}`).text().split('/')[0].replace('$', '')
        : $('.product-single__title').attr('add_cart_price').replace('$', '');
    } else {
      onClickPrice = isPriceOff4Visible
        ? $('.price-off-4').text().split('/')[0].replace('$', '')
        : $('.product-single__title').attr('add_cart_price').replace('$', '');
    }

    const newpricedata = (parseFloat(onClickPrice) * getIncreaseqty).toFixed(2);
    $('.get_product_price').text(`$${newpricedata}`);
  });

$('.pack-container').click(function(){
 var getPrice1 = parseFloat($(this).find('.cstmprice-off').text().replace(/[^0-9.]/g, '')) || 0;
var getPrice2 = parseFloat($('.product-single__title').attr('add_cart_price').replace('$',''))
   var getLength = $('.cstmpercentage-off:visible').length;
 var getQty1 = parseInt($('.js-qty__num').val());
      getPrice1 = getPrice1*getQty1;
    getPrice2 = getPrice2*getQty1;
    if(getLength > 0){
          console.log(' ',getPrice1.toFixed(2))
         // $('.get_product_price').text(`$${getPrice1.toFixed(2)}`)
    }else{
         console.log(' ',getPrice2.toFixed(2))
         // $('.get_product_price').text(`$${getPrice2.toFixed(2)}`)
    }


})
  $('.pack-container:first').addClass('pack-container-active');
  $('.pack-container').click(function() {
    $('.pack-container').removeClass('pack-container-active');
    $(this).addClass('pack-container-active');
  });